<template>
    <div>
        {{ (row.gross / 100) | money }}
        <span class="subtext" v-if="row.gross_potential > 0">
            {{ (row.gross_potential / 100) | money }}
        </span>
        <span class="subtext" v-else>
            &mdash;
        </span>
    </div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
